import { z } from 'zod';

export const ContactSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Invalid email address'),
  phone: z.string().optional(),
  message: z.string().min(10, 'Message must be at least 10 characters'),
});

export const UploadSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  style: z.array(z.string()).min(1, 'Select at least one style'),
  height: z.number().positive('Height must be a positive number'),
  width: z.number().positive('Width must be a positive number'),
  category: z.array(z.string()).min(1, 'Select at least one category'),
  status: z.enum(['available', 'sold']),
});
